// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YRJZq__layout {
  --content-inset: 5%;
}

.XXdSt__hook .KEyRr__tagLine {
    position: absolute;
    top: 3em;
    left: var(--content-inset);
    right: var(--content-inset);
    max-width: 15em;
  }

@media (min-width: 580px) {

.XXdSt__hook .KEyRr__tagLine {
      left: 8.5vw;
      top: 9vh;
  }
    }

.XXdSt__hook .W1c6S__wildIdeaText {
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 4vw;
    left: 8.5vw;
    top: calc(23em + 6vw);
    width: 45vw;
  }

.GSwSI__lionBulb {
  position: absolute;
  right: 0;
  top: calc(18em - min(32vw, 200px));
  width: 80%;
  max-width: 500px;
  overflow: hidden;
}

.GSwSI__lionBulb svg {
    width: 100%;
    transform: translate(30%, 0);
  }

.xQTux__content {
  position: relative;
  margin-top: min(max(75vh, calc(35em + 25vw)), 55em) !important;
  width: calc(100% - 2 * var(--content-inset));
  margin: 0 var(--content-inset) 7em;
}

.xQTux__content h2 {
    font-size: 3em;
    /* text-decoration: underline; */
    text-underline-offset: 0.45em;
  }

.xQTux__content .cSXSV__contentRow {
    display: flex;
    gap: 5vw;
  }

.xQTux__content .XttcY__hero {
    font-size: 2em;
  }

.xQTux__content .QfTAf__appCard {
    padding: 1em 1.5em;
    border: 1px solid white;
    border-radius: 16px;
    margin: 2em 0;
  }

.xQTux__content .QfTAf__appCard h3 {
      margin: 0.5em 0 1em !important;
    }

.xQTux__content .QfTAf__appCard h3 a {
        text-underline-offset: 0.3em;
      }

.fzYxb__mobileScreenshot {
  aspect-ratio: 3/4;
  overflow: hidden;
  border-radius: 16px;
  margin-bottom: 1.5em;
}

.fzYxb__mobileScreenshot .qguw8__screenshot {
    height: 100%;
    object-fit: cover;
  }

.qguw8__screenshot {
  width: 100%;
}

.uxdo1__phoneDemoLayout {
  width: 30vw;
  max-width: 30em;
}

.uxdo1__phoneDemoLayout .rIzhk__phoneDemoBlock {
    margin-bottom: 2em;
  }

.uxdo1__phoneDemoLayout .f5w7a__phone {
    box-shadow: 4px 4px 22px 4px rgba(10, 10, 10, 0.4);
  }

.uxdo1__phoneDemoLayout .l9jZn__phoneDemoCaption {
    display: flex;
    justify-content: center;
    padding: 1em 0;
  }

/* a watch, not a phone: the mock is its own frame */
._YjBL__watchDemo {
  display: block;
  width: 80%;
  margin: 0 auto;
  filter: drop-shadow(4px 4px 18px rgba(10, 10, 10, 0.4));
}

.nnCl5__rescueAllyScreenshot {
  --phone-frame-aspect-ratio: 9 / 19.5;
}

@media screen and (min-width: 768px) {

@media (max-color:2147477350) and (orientation: landscape) {
  .YRJZq__layout {
    --content-inset: 10%;
    display: flex;
    flex-direction: column;
  }

  .XXdSt__hook {
    position: absolute;
    top: 47vh;
    left: var(--content-inset);
    display: flex;
    flex-direction: column;
    font-weight: light;
  }

    .XXdSt__hook .KEyRr__tagLine {
      position: static;
      font-size: min(3vw, 3em) !important;
      margin-bottom: calc(1.6em - 3vw);
      max-width: unset;
    }

    .XXdSt__hook .W1c6S__wildIdeaText {
      position: static;
      width: auto;
    }

  .GSwSI__lionBulb {
    position: absolute;
    top: 55vh;
    right: var(--content-inset);
    width: 25%;
    min-width: 10em;
    overflow: visible;
  }

    .GSwSI__lionBulb svg {
      transform: translate(0, calc(-65% + 3vw));
    }

  .xQTux__content {
    margin-top: max(85vh, 32em) !important;
  }

  .uxdo1__phoneDemoLayout {
    margin: -2em -3em 0 0;
  }
}
}

@media not screen,not all and (min-width: 768px) {

@media (color:2147477350) and (orientation: landscape) {
  .YRJZq__layout {
    --content-inset: 10%;
    display: flex;
    flex-direction: column;
  }

  .XXdSt__hook {
    position: absolute;
    top: 47vh;
    left: var(--content-inset);
    display: flex;
    flex-direction: column;
    font-weight: light;
  }

    .XXdSt__hook .KEyRr__tagLine {
      position: static;
      font-size: min(3vw, 3em) !important;
      margin-bottom: calc(1.6em - 3vw);
      max-width: unset;
    }

    .XXdSt__hook .W1c6S__wildIdeaText {
      position: static;
      width: auto;
    }

  .GSwSI__lionBulb {
    position: absolute;
    top: 55vh;
    right: var(--content-inset);
    width: 25%;
    min-width: 10em;
    overflow: visible;
  }

    .GSwSI__lionBulb svg {
      transform: translate(0, calc(-65% + 3vw));
    }

  .xQTux__content {
    margin-top: max(85vh, 32em) !important;
  }

  .uxdo1__phoneDemoLayout {
    margin: -2em -3em 0 0;
  }
}
}
`, "",{"version":3,"sources":["webpack://./src/app/routes/home/HomeRoute.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAGE;IACE,kBAAkB;IAClB,QAAQ;IACR,0BAA0B;IAC1B,2BAA2B;IAC3B,eAAe;EAMjB;;AAJE;;AAPF;MAQI,WAAW;MACX,QAAQ;EAEZ;IADE;;AAGF;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,qBAAqB;IACrB,WAAW;EACb;;AAGF;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAMlB;;AAJE;IACE,WAAW;IACX,4BAA4B;EAC9B;;AAGF;EACE,kBAAkB;EAClB,8DAA8D;EAC9D,4CAA4C;EAC5C,kCAAkC;AA8BpC;;AA5BE;IACE,cAAc;IACd,gCAAgC;IAChC,6BAA6B;EAC/B;;AAEA;IACE,aAAa;IACb,QAAQ;EACV;;AAEA;IACE,cAAc;EAChB;;AAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EAQf;;AANE;MACE,8BAA8B;IAIhC;;AAHE;QACE,4BAA4B;MAC9B;;AAKN;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AAMtB;;AAJE;IACE,YAAY;IACZ,iBAAiB;EACnB;;AAGF;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AAejB;;AAbE;IACE,kBAAkB;EACpB;;AAEA;IACE,kDAAkD;EACpD;;AAEA;IACE,aAAa;IACb,uBAAuB;IACvB,cAAc;EAChB;;AAGF,oDAAoD;AACpD;EACE,cAAc;EACd,UAAU;EACV,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;AAAA;EACE;IACE,oBAAoB;IACpB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EAapB;;IAXE;MACE,gBAAgB;MAChB,mCAAmC;MACnC,gCAAgC;MAChC,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,WAAW;IACb;;EAGF;IACE,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,eAAe;IACf,iBAAiB;EAKnB;;IAHE;MACE,yCAAyC;IAC3C;;EAGF;IACE,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;AACF;AAAA;;AAhDA;;AAAA;EACE;IACE,oBAAoB;IACpB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EAapB;;IAXE;MACE,gBAAgB;MAChB,mCAAmC;MACnC,gCAAgC;MAChC,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,WAAW;IACb;;EAGF;IACE,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,eAAe;IACf,iBAAiB;EAKnB;;IAHE;MACE,yCAAyC;IAC3C;;EAGF;IACE,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;AACF;AAAA","sourcesContent":[".layout {\n  --content-inset: 5%;\n}\n\n.hook {\n  & .tagLine {\n    position: absolute;\n    top: 3em;\n    left: var(--content-inset);\n    right: var(--content-inset);\n    max-width: 15em;\n\n    @media (min-width: 580px) {\n      left: 8.5vw;\n      top: 9vh;\n    }\n  }\n\n  & .wildIdeaText {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    gap: 4vw;\n    left: 8.5vw;\n    top: calc(23em + 6vw);\n    width: 45vw;\n  }\n}\n\n.lionBulb {\n  position: absolute;\n  right: 0;\n  top: calc(18em - min(32vw, 200px));\n  width: 80%;\n  max-width: 500px;\n  overflow: hidden;\n\n  & svg {\n    width: 100%;\n    transform: translate(30%, 0);\n  }\n}\n\n.content {\n  position: relative;\n  margin-top: min(max(75vh, calc(35em + 25vw)), 55em) !important;\n  width: calc(100% - 2 * var(--content-inset));\n  margin: 0 var(--content-inset) 7em;\n\n  & h2 {\n    font-size: 3em;\n    /* text-decoration: underline; */\n    text-underline-offset: 0.45em;\n  }\n\n  & .contentRow {\n    display: flex;\n    gap: 5vw;\n  }\n\n  & .hero {\n    font-size: 2em;\n  }\n\n  & .appCard {\n    padding: 1em 1.5em;\n    border: 1px solid white;\n    border-radius: 16px;\n    margin: 2em 0;\n\n    & h3 {\n      margin: 0.5em 0 1em !important;\n      & a {\n        text-underline-offset: 0.3em;\n      }\n    }\n  }\n}\n\n.mobileScreenshot {\n  aspect-ratio: 3/4;\n  overflow: hidden;\n  border-radius: 16px;\n  margin-bottom: 1.5em;\n\n  & .screenshot {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.screenshot {\n  width: 100%;\n}\n\n.phoneDemoLayout {\n  width: 30vw;\n  max-width: 30em;\n\n  & .phoneDemoBlock {\n    margin-bottom: 2em;\n  }\n\n  & .phone {\n    box-shadow: 4px 4px 22px 4px rgba(10, 10, 10, 0.4);\n  }\n\n  & .phoneDemoCaption {\n    display: flex;\n    justify-content: center;\n    padding: 1em 0;\n  }\n}\n\n/* a watch, not a phone: the mock is its own frame */\n.watchDemo {\n  display: block;\n  width: 80%;\n  margin: 0 auto;\n  filter: drop-shadow(4px 4px 18px rgba(10, 10, 10, 0.4));\n}\n\n.rescueAllyScreenshot {\n  --phone-frame-aspect-ratio: 9 / 19.5;\n}\n\n@media (--screen-md) and (orientation: landscape) {\n  .layout {\n    --content-inset: 10%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .hook {\n    position: absolute;\n    top: 47vh;\n    left: var(--content-inset);\n    display: flex;\n    flex-direction: column;\n    font-weight: light;\n\n    & .tagLine {\n      position: static;\n      font-size: min(3vw, 3em) !important;\n      margin-bottom: calc(1.6em - 3vw);\n      max-width: unset;\n    }\n\n    & .wildIdeaText {\n      position: static;\n      width: auto;\n    }\n  }\n\n  .lionBulb {\n    position: absolute;\n    top: 55vh;\n    right: var(--content-inset);\n    width: 25%;\n    min-width: 10em;\n    overflow: visible;\n\n    & svg {\n      transform: translate(0, calc(-65% + 3vw));\n    }\n  }\n\n  .content {\n    margin-top: max(85vh, 32em) !important;\n  }\n\n  .phoneDemoLayout {\n    margin: -2em -3em 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `YRJZq__layout`;
export var hook = `XXdSt__hook`;
export var tagLine = `KEyRr__tagLine`;
export var wildIdeaText = `W1c6S__wildIdeaText`;
export var lionBulb = `GSwSI__lionBulb`;
export var content = `xQTux__content`;
export var contentRow = `cSXSV__contentRow`;
export var hero = `XttcY__hero`;
export var appCard = `QfTAf__appCard`;
export var mobileScreenshot = `fzYxb__mobileScreenshot`;
export var screenshot = `qguw8__screenshot`;
export var phoneDemoLayout = `uxdo1__phoneDemoLayout`;
export var phoneDemoBlock = `rIzhk__phoneDemoBlock`;
export var phone = `f5w7a__phone`;
export var phoneDemoCaption = `l9jZn__phoneDemoCaption`;
export var watchDemo = `_YjBL__watchDemo`;
export var rescueAllyScreenshot = `nnCl5__rescueAllyScreenshot`;
export default ___CSS_LOADER_EXPORT___;
